import fileFiled from './fileFiled'

export default fileFiled
